const request = {}

request.createRequest = function (stockMoveData) {
  return {
    name: stockMoveData.name,
    sortNumber: stockMoveData.sortNumber,
    isEnabled: stockMoveData.isEnabled
  }
}
export default { request }
